export const MONITORING_REQUEST = "MONITORING_REQUEST";
export const MONITORING_SUCCESS = "MONITORING_SUCCESS";
export const MONITORING_FAILURE = "MONITORING_FAILURE";
export const LOGOUT = "USER_LOGOUT";
